import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import {mapActions} from "vuex";
import {initializeApp} from "firebase/app";
import { doc, onSnapshot, setDoc,updateDoc, deleteField, getDoc } from "firebase/firestore";
import { getFirestore, serverTimestamp} from "firebase/firestore";
import { getMessaging, getToken, onMessage} from "firebase/messaging";
import firebase from "firebase/app";



const firebaseConfig = {
  apiKey: "AIzaSyBsxQ7czsApSpX_NeJY-9QX06V1LS_FuZ0",
  authDomain: "pines-6297b.firebaseapp.com",
  projectId: "pines-6297b",
  storageBucket: "pines-6297b.firebasestorage.app",
  messagingSenderId: "301235574941",
  appId: "1:301235574941:web:98356d6b059ff1582e5c74"
};
  
  const app = initializeApp(firebaseConfig);
 

createApp(App).use(store).use(router).mount('#app')





 